import { createAsyncActionType } from './index';

export const SEND_OTP = createAsyncActionType('ACCOUNT', 'SEND_OTP');

export const CHANGE_ACCOUNT_PASSWORD_SUBMIT = createAsyncActionType(
  'ACCOUNT',
  'CHANGE_ACCOUNT_PASSWORD_SUBMIT'
);
